import React, { useEffect, useRef, useState } from 'react'
import DatePicker from '../DatePicker/DatePicker'
import InputText from '../InputText/InputText'
import CalendarIcon from '../Icons/CalendarIcon'
import { IcaInputTime } from '../IcaElements/IcaInputTime'
import { formatDateToYMD } from '../../utils/dateUtils'
import './InputDate.scss'
import { useDeviceContext } from '../../contexts/device-context'

export interface IInputDateProps {
  id: string
  name: string
  ariaLabel: string
  date: Date,
  withTime?: boolean
  time?: string
  onDateChange: (date: string) => void
  onTimeChange?: (time: string) => void
  isToDate?: boolean
}

export default function InputDate ({ date, onDateChange, id, name, ariaLabel, withTime = false, time, onTimeChange, isToDate }: IInputDateProps) {

  const dateValueToLocale = new Date(date.toString())
  const inputDateRef = useRef<HTMLDivElement | null>(null)
  const datePickerRef = useRef<HTMLDivElement | null>(null)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const {deviceState} = useDeviceContext()

  const displayDateAndTime = (displayDate: Date) => {
    return `${formatDateToYMD(displayDate)}${time ? ', ' + time : ''}`
  }

  const changeDate = (date: Date) => {
    onDateChange(formatDateToYMD(date))
    if(!withTime) setShowDatePicker(false)
  }

  const changeTime = (time: string) => {
    const timePattern = /^(?:([01]\d|2[0-3]):([0-5]\d))?$/

    if (!timePattern.test(time)) {
      return
    } 
    if (onTimeChange) {
      onTimeChange(time)
    }
  }

  const onInputFocus = () => {
    setShowDatePicker(true)
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (datePickerRef.current && inputDateRef.current && !inputDateRef.current.contains(event.target as HTMLDivElement)) {
        setShowDatePicker(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [inputDateRef])

  return (
    <div className='input-date' ref={inputDateRef} onFocus={onInputFocus}>
      <InputText className='cursor-pointer outline-hidden mb-3 md:mb-4' name={name} id={id} placeholder="" value={displayDateAndTime(dateValueToLocale)} readonly ariaLabel={ariaLabel} type="text" icon={ deviceState.isMobile ? <></> : <CalendarIcon/>} onChange={() => null}  />
      {showDatePicker && 
      <div className={`input-date__date-picker border ${deviceState.isMobile && isToDate ? 'input-date__date-picker--adjust-toDate' : ''}`} ref={datePickerRef}>
        <>
          <div className='input-date__triangle-container'>
            <div className={`input-date__triangle border-left border-top ${deviceState.isMobile && isToDate ? 'input-date__triangle--adjust-toDate' : ''}`}></div>
          </div>
          <div className='max-w-[232px]'>
            <DatePicker onChange={changeDate} value={date} />
            {withTime && <IcaInputTime onChange={(e: React.ChangeEvent<HTMLInputElement>) => changeTime(e.target.value)} label='Tid' value={time} />}
          </div>
        </>
      </div>
      }
    </div>
  )
}
